import {
  hugeOne,
  type HugeNumber,
  type HugeNumberInput,
} from "@/shared/numbers";

export interface HovGainEffectSourceIntent {
  readonly bhgToHgPowerExponentBonus?: number;
  readonly hovGainCountMultiplier?: number;
  readonly hovGainMultiplier?: number;
  readonly h1gExponentBonus?: number;
  readonly hov1GainMultiplier?: HugeNumberInput;
  readonly hngRankScaleBaseBonus?: number;
}

export interface HovGainEffectAdoption {
  readonly bhgToHgPowerExponentBonus: number;
  readonly hovGainCountMultiplier: number;
  readonly hovGainMultiplier: number;
  readonly h1gExponentBonus: number;
  readonly hov1GainMultiplier: HugeNumber;
  readonly hngRankScaleBaseBonus: number;
}

export const NEUTRAL_HOV_GAIN_EFFECT_INTENT: HovGainEffectSourceIntent = {};

export function composeHovGainEffects(
  sources: readonly HovGainEffectSourceIntent[],
): HovGainEffectAdoption {
  let bhgToHgPowerExponentBonus = 0;
  let hovGainCountMultiplier = 1;
  let hovGainMultiplier = 1;
  let h1gExponentBonus = 0;
  let hov1GainMultiplier = hugeOne();
  let hngRankScaleBaseBonus = 0;

  for (const source of sources) {
    bhgToHgPowerExponentBonus += source.bhgToHgPowerExponentBonus ?? 0;
    hovGainCountMultiplier *= source.hovGainCountMultiplier ?? 1;
    hovGainMultiplier *= source.hovGainMultiplier ?? 1;
    h1gExponentBonus += source.h1gExponentBonus ?? 0;
    hov1GainMultiplier = hov1GainMultiplier.mul(source.hov1GainMultiplier ?? 1);
    hngRankScaleBaseBonus += source.hngRankScaleBaseBonus ?? 0;
  }

  return {
    bhgToHgPowerExponentBonus,
    hovGainCountMultiplier,
    hovGainMultiplier,
    h1gExponentBonus,
    hov1GainMultiplier,
    hngRankScaleBaseBonus,
  };
}
